import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  connect() {
    this.element.addEventListener('change', this.toggleMenu.bind(this))
  }

  toggleMenu(event) {
    const showInMenu = event.target.checked
    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
        'Accept': 'text/vnd.turbo-stream.html'
      },
      body: JSON.stringify({
        show_in_menu: showInMenu
      })
    }).then(response => response.text())
      .then(html => {
        Turbo.renderStreamMessage(html)
      })
  }

  disconnect() {
    this.element.removeEventListener('change', this.toggleMenu)
  }
}
